import { render, staticRenderFns } from "./CDKInfo.vue?vue&type=template&id=5630ee0e&scoped=true"
import script from "./CDKInfo.vue?vue&type=script&lang=js"
export * from "./CDKInfo.vue?vue&type=script&lang=js"
import style0 from "./CDKInfo.vue?vue&type=style&index=0&id=5630ee0e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5630ee0e",
  null
  
)

export default component.exports